<template>
    <span class="beta-badge" role="note" :aria-label="EXPLANATION" :title="EXPLANATION">
        BETA
    </span>
</template>

<script setup lang="ts">
/**
 * Пометка «раздел работает в бета-режиме».
 *
 * Намеренно без Vuetify и без composition API: v-tooltip не застаблен ни в
 * одной из спек поддержки (CreateTicketModal / SupportPage / SupportTicketPage),
 * и слот #activator там просто не отрисовался бы — бейдж исчезал бы из DOM в
 * тестах, оставаясь видимым в браузере.
 *
 * `title` — бонус для десктопного hover; смысл дублируется в aria-label,
 * потому что title не открывается ни по тапу, ни с клавиатуры.
 */
const EXPLANATION = 'Поддержка работает в бета-режиме: отвечаем вручную, возможны задержки';
</script>

<style scoped>
.beta-badge {
    display: inline-flex;
    align-items: center;
    /* На всех четырёх точках бейдж стоит рядом с текстом, который может
       переноситься — не даём разорвать его самого. */
    white-space: nowrap;
    padding: 1px 6px;
    border-radius: 6px;
    background: #ede7ff;
    color: #4c1d95;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.6px;
    text-transform: uppercase;
    line-height: 1.4;
    cursor: default;
}
</style>
